export enum SessionSortType {
  AscendingPrice = 'AscendingPrice',
}

export interface SessionSorting {
  sortType: SessionSortType;
}
export interface DeepLinkData {
  lang: string;
  currency?: string;
  property: string;
  guests: SessionGuests;
  stayPeriod: SessionStayPeriod;
  roomType?: string;
  promoCode?: string;
}

export interface SessionDisplay {
  culture: string;
  currency: string;
  countryCode: string;
}

export interface SessionContext {
  stayPeriod: SessionStayPeriod;
  guests: SessionGuests;
  selectedHotelId: number | string;
  excludeMixedRates?: boolean;
  disableCrossSell?: boolean;
  promoCode?: string;
}

export interface SessionCreate {
  sessionId: string;
  warnings: [];
}

export interface SessionCreateBody {
  engineId: string;
  isMonoHotel: boolean;
  display: SessionDisplay;
  context: SessionContext;
  metadata: SessionCreateMetadata;
}

export interface SessionCreateMetadata {
  customTrackingValues?: { [k: string]: string };
  application?: string;
  device?: string;
  ipAddress?: string;
}
export interface SessionStayPeriod {
  arrivalDate: string;
  departureDate: string;
}

export interface SessionGuests {
  adults: number;
  children: number;
  infants: number;
}
